<template>
    <div class="history">
        <ErrorBoundary>
            <div class="history_head">
                <div class="title">{{text('history.title')}}</div>
<!--                <DateRangePicker />-->
            </div>
            <WalletList />
            <Payment style="margin-bottom: 12px" />
            <div class="statistics">
                <img class="statistics_img" src="@/assets/images/history_degree.png" alt="">
                <img class="statistics_img statistics_img_mobile" src="@/assets/images/history_degree_mobile.png" alt="">
            </div>
            <div class="statistics_list">
                <div v-for="(item, idx) in statistics_list" :key="idx" :class="`statistics_item ${this.color(item.wallet_transaction_type)}`">
                    <div>
                        <div class="amount">{{item.amount}}</div>
                        <div class="contition">{{this.name(item.wallet_transaction_type)}}</div>
                    </div>
                    <div class="percent">{{item.percent}}%</div>
                </div>
            </div>
            <div class="main_line"></div>
            <TransactionsList />
        </ErrorBoundary>
    </div>
</template>

<script>
import WalletList from "@/components/WalletList.vue"
import Payment from '@/components/Payment.vue'
import TransactionsList from '@/components/transactions/TransactionsList.vue'
import DateRangePicker from '@/components/DateRangePicker.vue'
import ErrorBoundary from '@/components/ErrorBoundary.vue';


export default {
    name: "History",
    components: {
        ErrorBoundary,
        WalletList,
        Payment,
        TransactionsList,
        DateRangePicker
    },
    created() {
        this.getWalletStat()
    },
    computed: {
        authToken () {
            return this.$store.state.authToken
        }
    },
    data () {
        return {
            statistics_list: [
            //    {amount: '$159.45', condition: 'Пополнения', percent: '62%', class: 'green'},
            //    {amount: '$74.62', condition: 'Выводы', percent: '12%', class: 'red'},
            //    {amount: '$29.32', condition: 'Платежи', percent: '20%', class: 'yellow'},
            //    {amount: '$5.00', condition: 'Прочее', percent: '6%', class: 'blue'},
            ]
        }
    },
    methods: {
        name(wallet_transaction_type) {
            if (wallet_transaction_type === "default") {
                return this.text('history.category.default')
            } 

            return this.text('history.category.default')
        },
        color(wallet_transaction_type) {
            if (wallet_transaction_type === "default") {
                return "blue"
            } 

            return "blue"
        },
        async getWalletStat() {
            const { data } = await this.$http.get(
                '/v2/wallet/stat',
                {
                    "headers": {
                        "Authorization": "Token " + this.authToken
                    }
                }
            );
            this.statistics_list = data.results;            
        },
        async getTransactionList() {
            const { data } = await this.$http.get(
                '/v2/wallet/stat',
                {
                    "headers": {
                        "Authorization": "Token " + this.authToken
                    }
                }
            );
            this.transactionList = data.results;
        },
    }
}
</script>

<style lang="scss" scoped>
  .history {
    padding: 24px;
  }
  .history .history_head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 24px;
    margin-bottom: 32px;
  }
  .history .history_head .title {
    color: #FFF;
    font-family: "Rubik", sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 135%;
    letter-spacing: 0.4px;
  }
  .history .history_head .time {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .history .history_head .time span {
    color: #C7FF24;
    font-family: "Rubik", sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .history .statistics {
    display: flex;
    align-items: center;
    padding: 0 24px;
    margin-bottom: 25px;
    justify-content: space-between;
  }
  .history .statistics .statistics_img {
    width: 100%;
  }
  .history .statistics .statistics_img_mobile {
    display: none;
  }
  .history .statistics_list {
    padding: 0px 24px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 25px;
  }
  .history .statistics_list .statistics_item {
    width: calc(50% - 4px);
    border-radius: 8px;
    background: #3B363F;
    padding: 10px 8px 10px 12px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
  }
  .history .statistics_list .statistics_item::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 3px;
    height: 100%;
  }
  .history .statistics_list .statistics_item .amount {
    color: #FFF;
    font-family: "Rubik", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 135%;
    margin-bottom: 8px;
  }
  .history .statistics_list .statistics_item .contition {
    color: #A6A4B4;
    font-family: "Rubik", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .history .statistics_list .statistics_item .percent {
    color: #A6A4B4;
    font-family: "Rubik", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 135%;
  }
  .history .statistics_list .statistics_item.green::before {
    background: #00BF8E;
  }
  .history .statistics_list .statistics_item.red::before {
    background: #F34B47;
  }
  .history .statistics_list .statistics_item.yellow::before {
    background: #F4B52B;
  }
  .history .statistics_list .statistics_item.blue::before {
    background: #2C4A9B;
  }
  .history .main_line {
    border-radius: 10px;
    background: #312C35;
    height: 1px;
    width: calc(100% - 48px);
    margin: 0 auto 25px;
  }

  @media (max-width: 920px) {
    .history {
      border-radius: 16px;
      background: #262329;
      width: calc(100% - 40px);
      margin-left: 20px;
      padding-top: 16px;
    }
    .history .history_head {
      padding: 0 16px;
    }
    .history .history_head .title {
      font-size: 18px;
      letter-spacing: 0.36px;
    }
    .history .statistics {
      padding: 0px 16px;
    }
    .history .statistics .statistics_img {
      display: none;
    }
    .history .statistics .statistics_img_mobile {
      display: block;
    }
    .history .statistics_list {
      padding-left: 16px;
      padding-right: 16px;
    }
    .history .transaction_wrapper {
      margin: 0;
      padding: 0;
    }
    .history .transaction_wrapper .title {
      display: none;
    }
  }

  @media (max-width: 576px) {
    .history {
      padding: 16px;
    }
  }



</style>